var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMessengerLogo = function SvgIconMessengerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.207 9.793a1 1 0 0 0-1.414 0l-3 3a1 1 0 1 0 1.414 1.414l2.293-2.293 2.293 2.293a1 1 0 0 0 1.414 0l3-3a1 1 0 0 0-1.414-1.414L13.5 12.086z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.856 21.825a10 10 0 0 1-6.577-1.006l-2.71.767a1.74 1.74 0 0 1-2.155-2.155l.767-2.71a9.99 9.99 0 1 1 10.674 5.104M7.09 5.698a7.99 7.99 0 1 1 .828 13.186 1 1 0 0 0-.784-.102l-2.672.756.757-2.672a1 1 0 0 0-.102-.782A7.99 7.99 0 0 1 7.09 5.698",
    clipRule: "evenodd"
  }))));
};
export default SvgIconMessengerLogo;